import React, { useEffect, useState } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import arrowRight from '../../images/arrow-pro-right.svg';
import Slider from "react-slick";
import '../../sass/components/flexibleModules/_components.genericMultipleTabBasedComponent.scss';
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"

const GenericMultipleTabBasedComponent = ({ data }) => {
    const [tabSection, setTabSection] = useState(data.genericMultipleTabBasedComponentSections[0].tabHeader);

    const tabFilter = (tabValue) => {
        setTabSection(tabValue);
        window.scrollTo({
            top: document.querySelector('.cp-genericMultipleBasedTab__tabContent').offsetTop - 300,
            left: 0,
            behavior: 'smooth'
        });
    }

    let settings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 10000,
                settings: 'unslick'
            }
        ],
    }

    const [isRendered, setIsRendered] = useState(false);

    useEffect(() => {
        setIsRendered(true);
    }, []);

    const scrollToRef = (ref) => {
        if (ref) {
            window.scrollTo({
                top: document.querySelector(ref).offsetTop - 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    return (
        <div className={`cp-genericMultipleBasedTab ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className={`cp-genericMultipleBasedTab__inner ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.genericMultipleTabBasedComponentMainHeader &&
                    <h2 dangerouslySetInnerHTML={{ __html: data.genericMultipleTabBasedComponentMainHeader }} />
                }
                {data.genericMultipleTabBasedComponentMainTeaser &&
                    <div dangerouslySetInnerHTML={{ __html: data.genericMultipleTabBasedComponentMainTeaser }} />
                }
                {process.env.GATSBY_LANG === "de" ?
                    <span>Bitte klicken Sie auf ein Feature, um mehr zu erfahren</span>
                    :
                    <span>Select a feature to explore</span>
                }
                {data.genericMultipleTabBasedComponentSections &&
                    <>
                        <div className="cp-genericMultipleBasedTab__tabs l--flex">
                            {data.overrideClass === 'l--noTabs' ?
                                <>
                                    {data.genericMultipleTabBasedComponentSections.map((tab, index) => (
                                        <React.Fragment key={index}>
                                            {tab.contentSectionsRepeater ?
                                                <button className={tab.tabHeader === tabSection ? 'is-active' : ''} onClick={e => tabFilter(e.currentTarget.getAttribute('data-value'))} data-value={tab.tabHeader}>
                                                    {tab.tabIcon &&
                                                        <img loading="lazy" src={tab.tabIcon.sourceUrl} alt={tab.tabIcon.altText} />
                                                    }
                                                    {tab.tabHeader &&
                                                        <h3>{tab.tabHeader}</h3>
                                                    }
                                                    {tab.tabTeaser &&
                                                        <span>{tab.tabTeaser}</span>
                                                    }
                                                    {!tab.tabGenericLink &&
                                                        <span className="l-comingSoon">Coming Soon</span>
                                                    }
                                                    <span className="l--absoluteIcon"></span>
                                                </button>
                                                :
                                                <span className="l-span">
                                                    {tab.tabIcon &&
                                                        <img loading="lazy" src={tab.tabIcon.sourceUrl} alt={tab.tabIcon.altText} />
                                                    }
                                                    {tab.tabHeader &&
                                                        <h3>{tab.tabHeader}</h3>
                                                    }
                                                    {tab.tabTeaser &&
                                                        <span>{tab.tabTeaser}</span>
                                                    }
                                                    {!tab.tabGenericLink &&
                                                        <span className="l-comingSoon">Coming Soon</span>
                                                    }
                                                </span>
                                            }
                                        </React.Fragment>
                                    ))}
                                </>
                                :
                                <>
                                    {isRendered && (
                                        <Slider {...settings}>
                                            {data.genericMultipleTabBasedComponentSections.map((tab, index) => (
                                                <React.Fragment key={index}>
                                                    {tab.contentSectionsRepeater ?
                                                        <button className={tab.tabHeader === tabSection ? 'is-active' : ''} onClick={e => tabFilter(e.currentTarget.getAttribute('data-value'))} data-value={tab.tabHeader}>
                                                            <div className="l--flex">
                                                                {tab.tabIcon &&
                                                                    <img loading="lazy" src={tab.tabIcon.sourceUrl} alt={tab.tabIcon.altText} />
                                                                }
                                                                {tab.tabHeader &&
                                                                    <h3>{tab.tabHeader}</h3>
                                                                }
                                                            </div>
                                                            {/* {tab.tabTeaser &&
                                                                <span>{tab.tabTeaser}</span>
                                                            } */ }
                                                            {!tab.tabGenericLink &&
                                                                <span className="l-comingSoon">Coming Soon</span>
                                                            }
                                                            {/* <span className="l--absoluteIcon"></span> */}
                                                        </button>
                                                        :
                                                        <span className="l-span">
                                                            <div className="l--flex">
                                                                {tab.tabIcon &&
                                                                    <img loading="lazy" src={tab.tabIcon.sourceUrl} alt={tab.tabIcon.altText} />
                                                                }
                                                                {tab.tabHeader &&
                                                                    <h3>{tab.tabHeader}</h3>
                                                                }
                                                            </div>
                                                            {/* {tab.tabTeaser &&
                                                                <span>{tab.tabTeaser}</span>
                                                            }*/}
                                                            {!tab.tabGenericLink &&
                                                                <span className="l-comingSoon">Coming Soon</span>
                                                            }
                                                        </span>
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </Slider>
                                    )}
                                </>
                            }
                        </div>
                        <div className="cp-genericMultipleBasedTab__tabContent">
                            {data.genericMultipleTabBasedComponentSections.map((tab, index) => (
                                <>
                                    {
                                        tab.tabHeader === tabSection &&
                                        <React.Fragment key={index}>
                                            {tab.contentSubHeader &&
                                                <span className={`l--highlight l--number${index}`}>{tab.contentSubHeader}</span>
                                            }
                                            {tab.contentHeader &&
                                                <h2>{tab.contentHeader}</h2>
                                            }
                                            {tab.contentSectionsRepeater &&
                                                <div className="cp-genericMultipleBasedTab__tabContent-section l--flex">
                                                    {tab.contentSectionsRepeater.map((section, index) => (
                                                        <div className="cp-genericMultipleBasedTab__tabContent-section-inner" key={index}>
                                                            {section.image &&
                                                                <GatsbyImage image={getImage(section.image.gatsbyImage)} alt={section.image.altText} />
                                                            }
                                                            {section.header &&
                                                                <h4>{section.header}</h4>
                                                            }
                                                            {section.teaser &&
                                                                <p dangerouslySetInnerHTML={{ __html: section.teaser }} />
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                            {tab.tabGenericLink &&
                                                <>
                                                    {tab.tabGenericLink.url === '#anchorTop' ?
                                                        <div className="l-relativeButton">
                                                            <button onClick={() => scrollToRef(`.cp-halfHalfMarketocomponent`)} className="l-button">
                                                                <span>{tab.tabGenericLink.title}</span>
                                                                {data.overrideClass === 'l-LightText' || data.overrideClass === 'l-textLinkSection' ?
                                                                    <StaticImage src="../../images/arrow-pro-right.svg" alt=""></StaticImage>
                                                                    :
                                                                    <StaticImage src="../../images/arrow-right-white.svg" alt=""></StaticImage>
                                                                }
                                                            </button>
                                                            <button onClick={() => scrollToRef(`.cp-halfHalfMarketocomponent`)} className="l-button l-backgroundHover">
                                                                <span>{tab.tabGenericLink.title}</span>
                                                                {data.overrideClass === 'l-LightText' || data.overrideClass === 'l-textLinkSection' ?
                                                                    <StaticImage src="../../images/arrow-pro-right.svg" alt=""></StaticImage>
                                                                    :
                                                                    <StaticImage src="../../images/arrow-right-white.svg" alt=""></StaticImage>
                                                                }
                                                            </button>
                                                        </div>
                                                        :
                                                        <a className="l--textlink l--flex" href={tab.tabGenericLink.url} target={tab.tabGenericLink.target}>
                                                            <span>{tab.tabGenericLink.title}</span>
                                                            <img src={arrowRight} alt="" />
                                                        </a>
                                                    }
                                                </>
                                            }
                                        </React.Fragment>
                                    }
                                </>
                            ))}
                        </div>
                    </>
                }
            </div>
        </div>
    );
}

export default GenericMultipleTabBasedComponent;